import { handleFeed } from "../../../feed/handleFeed";
import { SkipFeedGuide } from "../types";
import { DEFAULT_ERROR_MESSAGE } from "../../../ui/constants";

export const skipFeedGuide = async (skipData?: SkipFeedGuide) => {
  if (!skipData) return;
  const { handlerParams, companyId, siteId, demoLink } = skipData;
  const { handleScheduleFeed, handleTriggerFeed } = handleFeed(
    handlerParams,
    companyId,
    siteId,
  );
  let feedSuccess = await handleScheduleFeed(false, "", [
    { url: demoLink, entityType: "product" },
  ]);
  if (feedSuccess) feedSuccess = !!(await handleTriggerFeed());
  if (!feedSuccess) {
    handlerParams.notify(
      "Error",
      `${DEFAULT_ERROR_MESSAGE} Please restart importing products feed`,
    );
  }
};
